// CacheKey e7391f7cbcbef6a3ee76da2685b2c52a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { request } from '@services/EvolveApiService'

export default {
  search: options =>
    request('post', '/vue/quicksearch_patients/search', options),
}
